/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:13
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-10 11:20:11
 * @FilePath: \eu-eswop-official-site\src\main.js
 * @Description:
 */
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import resize from './utils/resize'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper.min.css'
import './assets/css/font.css'
import ElementUI from 'element-ui';
import {i18n} from './locales'
import 'element-ui/lib/theme-chalk/index.css';
import { isPC, isOpenInWebview } from "./utils/util.js";
import {
  Step,
  Icon,
  Steps,
  Uploader,
  Button,
  Toast,
  Dialog,
  Lazyload,
  Loading,
  List,
  PullRefresh,
  Skeleton,
  Popup,
  ImagePreview,
  Overlay,
  Image
} from 'vant'
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import 'lib-flexible'
Vue.config.productionTip = false
resize(document, window)
Vue.use(VueAwesomeSwiper)

Vue.use(ElementUI);
if (isPC()) {

} else {
  Vue.use(Step)
  Vue.use(Icon)
  Vue.use(Steps)
  Vue.use(Uploader)
  Vue.use(Button)
  Vue.use(Toast)
  Vue.use(Dialog)
  Vue.use(Lazyload)
  Vue.use(Loading)
  Vue.use(List)
  Vue.use(PullRefresh)
  Vue.use(Skeleton)
  Vue.use(Popup)
  Vue.use(ImagePreview)
  Vue.use(Overlay)
  Vue.use(Image)
}

Vue.prototype.$isOpenInWebview = isOpenInWebview();

router.beforeEach((to, from, next) => {
  // 在每次路由改变前将滚动条置顶
  window.scrollTo(0, 0);
  next();
});

// 初始化sensors
// initSensorsData()
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
